module.exports = __webpack_public_path__ + "d901d5e6a49413ec2e0d389466b698e6.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/nordddb-logo-2.svg
// module id = 3VuF
// module chunks = 8